import {UserDto} from '@domain/pom'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {QueryKeyName, getUser} from '../../common/backend'

export const useUserById = (id?: string) => {
  return useQuery<UserDto | undefined, AxiosError>({
    queryKey: [QueryKeyName.GetUser, id],
    queryFn: async () => {
      if (id) {
        return await getUser({id})
      }
    }
  })
}
